/* eslint-disable  react/prop-types */

import React from 'react';

const LeftCaret = ({
  width = 16,
  height = 16,
  strokeColor = '#6D7184',
  style = {},
}) => (
  <svg
    style={style}
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 4L6 8L10 12"
      stroke={strokeColor}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LeftCaret;
